import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useQueryClient } from "@tanstack/react-query";
import { CheckCircleOutlined, LoadingOutlined } from "@ant-design/icons";
import {
  ROUTE,
  SYSTEM_CONFIG_CACHE_KEY,
  SYSTEM_CONFIG_CACHE_TS_KEY,
} from "../../Constant";
import { useAuthChecker } from "../../Context/useAuthContext";
import { useSystemConfigRequest } from "../../Services/system_config_service";

export const LoginSuccessPage = () => {
  const navigate = useNavigate();
  const { isSystemAdmin } = useAuthChecker();
  const [progress, setProgress] = useState(0);
  const fetchConfig = useSystemConfigRequest();

  useEffect(() => {
    if (isSystemAdmin) return;
    fetchConfig.mutate(undefined, {
      onSuccess: (res) => {
        if (res?.success && res.data) {
          localStorage.setItem(
            SYSTEM_CONFIG_CACHE_KEY,
            JSON.stringify(res.data),
          );
          localStorage.setItem(
            SYSTEM_CONFIG_CACHE_TS_KEY,
            Date.now().toString(),
          );
        }
      },
      onError: (e) => {
        console.error("Failed to fetch system config:", e);
      },
    });
  }, [fetchConfig, isSystemAdmin]);

  useEffect(() => {
    const interval = setInterval(() => {
      setProgress((prev) => {
        if (prev >= 100) {
          clearInterval(interval);
          return 100;
        }
        return prev + 2;
      });
    }, 40);

    const timer = setTimeout(() => {
      navigate(
        isSystemAdmin
          ? `/system-admin/${ROUTE.system_admin_tenants}`
          : `/system/${ROUTE.sales_billing}`,
      );
    }, 2000);

    return () => {
      clearTimeout(timer);
      clearInterval(interval);
    };
  }, [navigate, isSystemAdmin]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-50">
      <div className="flex w-full max-w-sm flex-col items-center text-center bg-white px-10 py-12 rounded-lg border border-gray-200 shadow-sm">
        <div className="flex items-center justify-center w-16 h-16 rounded-full bg-blue-50 mb-6">
          <CheckCircleOutlined className="text-blue-500 text-3xl" />
        </div>
        <h1 className="text-xl font-semibold text-gray-900 mb-2">
          Login Successful
        </h1>
        <p className="text-sm text-gray-400 mb-8 leading-relaxed">
          Welcome back! Loading your workspace...
        </p>
        <div className="w-full bg-gray-100 h-1 rounded-full overflow-hidden mb-4">
          <div
            className="bg-blue-500 h-full rounded-full transition-all duration-75 ease-linear"
            style={{ width: `${progress}%` }}
          />
        </div>
        <span className="text-xs text-gray-400 flex items-center gap-1.5">
          <LoadingOutlined className="text-gray-300" />
          Redirecting to POS system...
        </span>
      </div>
    </div>
  );
};
